import React, { Component } from "react";

class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accordion: [
        {
          id: 1,
          classname: "accordion-item active",
          heading: "Želim uvesti CityX u svoj grad. Koji su potrebni koraci?",
          text: "Hvala na interesu u ime Vaših sugrađana koji zasigurno žele da i njihov grad postane dio najveće smart city mreže. Javite nam se na info@cityx.hr, a CityX ekipa će se potruditi da se priključenje grada što prije realizira.",
        },
        {
          id: 2,
          classname: "accordion-item",
          heading:
            "IMAM TVRTKU I ŽELIO BIH JE UVRSTITI U PONUDU CITYX-A. ŠTO BI TREBAO  NAPRAVITI?",
          text: "Bilo da imate školu, teretanu, sportski klub ili, pak, radionicu, čije usluge želite ponuditi građanima, na pravom ste mjestu! U našem individualnom pristupu svakom klijentu pomno ćemo razmotriti Vašu ponudu i predložiti najbolje rješenje za implementaciju u aplikaciju. Javite nam se putem maila na info@cityx.hr kako bi u najkraćem mogućem roku dogovorili suradnju.",
        },
        {
          id: 3,
          classname: "accordion-item",
          heading:
            "TURISTIČKI SAM VODIČ I HTIO BIH BITI UVRŠTEN U CITYX MREŽU TURSITIČKIH VODIČA HRVATSKE? ZANIMA ME PROCEDURA.",
          text: "Ako ste licencirani vodič koji ima obrt, dovoljno je poslati informacije o području na kojem vršite uslugu i na kojim jezicima. Slobodno nam pošaljite mail na info@cityx.hr kako bi Vam pružili detaljnije informacije.",
        },
        {
          id: 4,
          classname: "accordion-item",
          heading:
            "NA KOJI NAČIN MOŽEMO ATRAKCIJU (MUZEJ, GALERIJU I SL.) UKLJUČITI U APLIKACIJU?",
          text: "Proces je vrlo jednostavan. Nakon dogovorenih poslovnih uvjeta, potpisuje se ugovor koji nije određen vremenskim trajanjem. Aplikacijom je osigurana online kupnja (cijeli sustav naplate), kao i skener za provjeru ulaznica kupljenih putem aplikacije. Korištenje aplikacije je besplatno, kako za turiste, tako i za naše partnere. Kontaktirajte nas putem maila na info@cityx.hr za više detalja.",
        },
        {
          id: 5,
          classname: "accordion-item",
          heading:
            "ZANIMA ME KAKO, KAO TRENER, MOGU BITI DIO PILOT PROJEKTA SPORTTER?",
          text: "Dovoljno je na mail info@cityx.hr poslati kratak životopis (sportska karijera). Detaljnije informacije ćete u najkraćem mogućem roku dobiti od naših sportskih suradnika.",
        },
      ],
    };
  }

  render() {
    return (
      <div className="col-md-6">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={0}
          data-mobile={0}
          data-smobile={35}
        />
        <div
          className="themesflat-content-box"
          data-margin="0 0 0 18px"
          data-mobilemargin="0 0 0 0"
        >
          <div className="themesflat-headings style-1 clearfix">
            <h2 className="heading">FAQs</h2>
            <div className="sep has-width w80 accent-bg margin-top-11 clearfix" />
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={38}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="themesflat-accordions style-1 has-icon icon-left iconstyle-1 clearfix">
            {this.state.accordion.map((data) => (
              <div className={data.classname} key={data.id}>
                <h3 className="accordion-heading">
                  <span className="inner">{data.heading}</span>
                </h3>
                <div className="accordion-content">
                  <div>{data.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Faq;
